"use strict";
/**
 * 
 *
 * Description 策划中心 指挥监测中心 稿件传播力管理nav切换
 * Author: gaokz 2018-5-10
 */
angular.module('manuscriptAnalysisNavModule', [])
    .controller('manuscriptAnalysisNavController', ["$scope", "$location", "trsHttpService", function($scope, $location, trsHttpService) {
        initStatus();
        initData();
        function initStatus() {
            $scope.currManuscriptAnalysisModule = $location.path().split("/").pop();
            $scope.manuscriptAnalysisNavTab = {
                'rankinglist': false,
                'custommanuscriptprop': false,
            };
            $scope.manuscriptAnalysisNavTab[$scope.currManuscriptAnalysisModule] = true;            
        }
        function initData() {

        }
    }]);